import { lazy } from "react";

const UpdateTransferPolicyPage = lazy(() => import("./update"));

export { UpdateTransferPolicyPage };
